import { hookupMarker } from "../../../../../utils/helpers/mapMarkerHelpers";
import L from "leaflet";

const HookupLayers = (
  hookupPointsParsed,
  hookupName,
  workLogId
) => {
  let hookupMarkerList = [];
  hookupPointsParsed[hookupName].coordinates.forEach(
    (hookupCoordinates, index) => {
      const hookupMapMarker = hookupMarker(
        hookupName,
        workLogId,
        hookupCoordinates,
        index
      );
      hookupMarkerList.push(hookupMapMarker);
    }
  );
  const hookupPointsMarkerLayerGroup = L.layerGroup(hookupMarkerList);
  hookupPointsMarkerLayerGroup.id = `${hookupName}-${workLogId}`;
  return hookupPointsMarkerLayerGroup;
};

export default HookupLayers;
